import { ReminderService } from './../../services/reminder.service';
import { Paginate } from './../../models/Paginate';
import { Sticker } from '@model/Sticker';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-project-reminders',
  templateUrl: './project-reminders.component.html',
  styleUrls: ['./project-reminders.component.scss']
})
export class ProjectRemindersComponent implements OnInit {

  reminders: Paginate<Sticker> = null;

  constructor(
    private reminderService: ReminderService
  ) { }

  ngOnInit() {
    this.reminderService.paginate().subscribe((res: Paginate<Sticker>) => {
      this.reminders = res;
    });
  }

}
